import { Paper } from '@material-ui/core';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import React from 'react';

const CenteredPanelLayout = ({ children, title }) => (
  <div className="centered-panel-layout">
    <div>
      <h1 className="display-3">{title}</h1>

      <Paper className="centered-panel" elevation={5}>
        {children}
      </Paper>
    </div>
  </div>
);

CenteredPanelLayout.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  title: string.isRequired,
};

CenteredPanelLayout.defaultProps = {
  children: null,
};

export default CenteredPanelLayout;
